// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { scheduleReminderModalStyles } from "@plumberssupply/Overrides/Components/ScheduleReminderModal";
import { xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

scheduleReminderModalStyles.modal = {
    cssOverrides: {
        modalContent: css`
            ${xScreen("gte", "md")} {
                overflow-y: visible;
            }
        `,
    },
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
            .react-datetime-picker__clear-button {
                display: none;
            }
        `,
    },
    clearIconProps: {
        css: css`
            display: none;
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
            .react-datetime-picker__clear-button {
                display: none;
            }
        `,
    },
    clearIconProps: {
        css: css`
            display: none;
        `,
    },
};

scheduleReminderModalStyles.bottomRowGridItem = {
    width: 12,
    css: css`
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            row-gap: 20px;
        }
    `,
};
scheduleReminderModalStyles.stopButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
        ${xScreen("gt", "md")} {
            margin-right: 15px;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-right: 0;
        }
    `,
};
scheduleReminderModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
scheduleReminderModalStyles.scheduleButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.stopAndScheduleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            row-gap: 20px;
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.cancelButtonsGridItem = {
    css: css`
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            row-gap: 20px;
        }
    `,
};
scheduleReminderModalStyles.dismissCancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.confirmCancelButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
